export const filterStudentsByClass = (data, selectedClass) => {
  if (!data || !data.students) return { students: [] };
  
  if (selectedClass === 'all') return data;
  
  const filteredStudents = data.students.filter(student => student.class_admitted === selectedClass);
  return { students: filteredStudents };
};